// Full-colour brand logos. LinkedIn is the official mark, Instagram is the Font Awesome
// glyph (CC BY 4.0) in the brand gradient, the rest are Iconify "logos" by Gil Barbara (CC0).
import instagram from "@/assets/social/instagram.svg";
import whatsapp from "@/assets/social/whatsapp.svg";
import linkedin from "@/assets/social/linkedin.svg";
import x from "@/assets/social/x.svg";
import gmail from "@/assets/social/gmail.svg";
import github from "@/assets/social/github.svg";
import youtube from "@/assets/social/youtube.svg";
import dailydev from "@/assets/social/dailydev.svg";
import cssbattle from "@/assets/social/cssbattle.webp";

export const SOCIALS = [
  { label: "Instagram", href: "https://instagram.com/chirag__gadhvi", icon: instagram },
  { label: "WhatsApp", href: "https://wa.me/917995972862", icon: whatsapp },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/chiraggadhvi7272/", icon: linkedin },
  { label: "X", href: "https://x.com/Chirag__Gadhvi", icon: x, mono: true },
  { label: "Gmail", href: "mailto:chiraggadhvi7272@gmail.com", icon: gmail },
  { label: "GitHub", href: "https://github.com/ChiragGadhvi", icon: github, mono: true },
  { label: "YouTube", href: "https://www.youtube.com/@chirag_gadhvi", icon: youtube },
];

// The chat menu also lists coding profiles (daily.dev: Iconify "logos", CSS Battle: its own favicon)
export const CHAT_SOCIALS = [
  ...SOCIALS,
  { label: "daily.dev", href: "https://app.daily.dev/chiraggadhvi", icon: dailydev, mono: true },
  { label: "CSS Battle", href: "https://cssbattle.dev/player/chiraggadhvi", icon: cssbattle },
];

export type Social = (typeof CHAT_SOCIALS)[number];

// Black marks (X, GitHub) flip to white on dark backgrounds
export function SocialIcon({ social, className = "h-4 w-4" }: { social: Social; className?: string }) {
  return (
    <img
      src={social.icon}
      alt=""
      width={16}
      height={16}
      loading="lazy"
      decoding="async"
      className={`object-contain ${social.mono ? "dark:invert" : ""} ${className}`}
    />
  );
}

export function socialLinkProps(social: Social) {
  return {
    href: social.href,
    target: social.href.startsWith("mailto") ? undefined : "_blank",
    rel: "noopener noreferrer",
    "aria-label": social.label,
    title: social.label,
  };
}

// Bordered tiles, same as the Skills grid (used by the footer); `only` picks a subset by label
export function SocialLinks({ className = "", only }: { className?: string; only?: string[] }) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {SOCIALS.filter((s) => !only || only.includes(s.label)).map((s) => (
        <a
          key={s.label}
          {...socialLinkProps(s)}
          className="w-9 h-9 flex items-center justify-center rounded-lg border border-border bg-card transition-transform duration-200 hover:-translate-y-0.5"
        >
          <SocialIcon social={s} />
        </a>
      ))}
    </div>
  );
}
